import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const CheckSquare = createSvgIcon(
  () => (
    <path d="M39.0625 43.75C41.6016 43.75 43.75 41.6992 43.75 39.0625V4.6875C43.75 2.14844 41.6016 0 39.0625 0H4.6875C2.05078 0 0 2.14844 0 4.6875V39.0625C0 41.6992 2.05078 43.75 4.6875 43.75H39.0625ZM19.043 34.1797C18.457 34.8633 17.3828 34.8633 16.7969 34.1797L6.64062 24.0234C6.05469 23.4375 6.05469 22.4609 6.64062 21.875L8.88672 19.6289C9.47266 19.043 10.4492 19.043 11.0352 19.6289L17.9688 26.4648L32.6172 11.8164C33.2031 11.2305 34.1797 11.2305 34.7656 11.8164L37.0117 14.0625C37.5977 14.6484 37.5977 15.625 37.0117 16.2109L19.043 34.1797Z" />
  ),
  '0 0 44 44'
);
